import { LOGO_URL } from "../lib/api";

export const PageRocket = ({ className = "w-40 lg:w-56" }) => (
  <img
    src={LOGO_URL}
    alt=""
    aria-hidden="true"
    className={`hidden md:block object-contain animate-float drop-shadow-[0_20px_50px_rgba(212,175,55,0.35)] pointer-events-none select-none ${className}`}
    data-testid="page-rocket"
  />
);
